import React, { useEffect, useRef, useState } from "react";
import ReactGA from "react-ga";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectIsGAInitialized } from "../../store/selectors/appSelectors";
import { setIsGAInitialized } from "../../store/slices/appSlice";

const _UNSAFE_GA_ID_BETA = "G-01W6EVJ1NR";
const _UNSAFE_GA_ID_REACT = "G-FV00Z9FYSZ";

interface GlobalWindow extends Window {
  dataLayer: any[];
}

const GoogleAnalyticsHandler = () => {
  const location = useLocation();
  const pathnameRef = useRef(null);
  const isGAInitialized = useAppSelector(selectIsGAInitialized);
  const dispatch = useAppDispatch();
  const isBetaVersion =
    window.location.href.includes("beta-media") ||
    window.location.href.includes("react-media");

  useEffect(() => {
    ReactGA.initialize(
      isBetaVersion ? _UNSAFE_GA_ID_BETA : _UNSAFE_GA_ID_REACT
    );
    dispatch(setIsGAInitialized(true));
  }, []);

  useEffect(() => {
    if (pathnameRef.current === location.pathname) {
      return;
    }

    pathnameRef.current = location.pathname;

    if (location.state && location.state.action === "PUSH" && isGAInitialized) {
      (window as unknown as GlobalWindow).dataLayer =
        (window as unknown as GlobalWindow).dataLayer || [];

      const customEventPayload = {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname,
      };

      (window as unknown as GlobalWindow).dataLayer.push(customEventPayload);
    }
  }, [location.pathname, isGAInitialized]);

  return <></>;
};

export default GoogleAnalyticsHandler;
